import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from '@mui/material'
import { useBiTheme } from '../state/BiThemeContext'
import { THEME_OPTIONS, type BiThemeId } from '../theme'

/** Preferências do BI (tema). Paridade de menu com o Financeiro. */
export function ConfiguracoesPage() {
  const { themeId, setThemeId } = useBiTheme()

  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
        Configurações
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Preferências de aparência do Fiesta BI. Os dados de negócio e o login são os mesmos do
        ecossistema Fiestaup.
      </Typography>

      <Paper sx={{ p: 2.5 }} elevation={0} variant="outlined">
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Tema visual
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Escolha o tema da interface. A preferência fica guardada neste browser.
        </Typography>
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel id="cfg-theme-label">Tema</InputLabel>
          <Select
            labelId="cfg-theme-label"
            label="Tema"
            value={themeId}
            onChange={(e) => setThemeId(e.target.value as BiThemeId)}
          >
            {THEME_OPTIONS.map((opt) => (
              <MenuItem key={opt.id} value={opt.id}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Paper>
    </Box>
  )
}
